module.exports = __webpack_public_path__ + "static/media/lorelai-intro-1.94f25d0d.wav";